import { render } from "./TaskDetailPage.vue?vue&type=template&id=6ed4a2a2&scoped=true"
import script from "./TaskDetailPage.vue?vue&type=script&lang=js"
export * from "./TaskDetailPage.vue?vue&type=script&lang=js"

import "./TaskDetailPage.vue?vue&type=style&index=0&id=6ed4a2a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ed4a2a2"]])

export default __exports__